import { SdfLink } from "@waypoint/react-components";
import { LoginBannerContainer, BannerTextContainer } from "./styles";
import { useTranslatedObject } from "../../utils/translation";
import { setActiveTab } from "@headless-shell/store";
import { useDispatch, useSelector } from "react-redux";

const LoginBanner = () => {
  const signInText = useTranslatedObject('signin_text');
  const signInLink = useTranslatedObject('sign_in');
  const dispatch = useDispatch();

  // signIn data from CMS
  const signInData = useSelector(state => state.app?.homeContent?.signInPrompt);

  const link       = signInData?.link        || '/login';
  const linkText   = signInData?.linkText     || signInLink;
  const promptText = signInData?.promptText   || signInText;
  const bgColor    = signInData?.backgroundColor || undefined;
  const textColor  = signInData?.textColor       || undefined;

  const handleSignInClick = () => {
    const returnUrl = window.location.pathname + window.location.search;
    window.dispatchEvent(new CustomEvent('auth-request-login', { detail: { returnUrl } }));
    dispatch(setActiveTab(''));
  }

  return (
    <LoginBannerContainer role="region" aria-label="Sign in banner" bgColor={bgColor}>
      <BannerTextContainer textColor={textColor}>
        <SdfLink href={link} onClick={handleSignInClick}>{linkText}</SdfLink> &nbsp; {promptText}
      </BannerTextContainer>
    </LoginBannerContainer>
  );
};

export default LoginBanner;
